import { useCacheSlice } from '../hooks'

export type Application = {
  application: string
}

export function useApplicationsCache() {
  const { data, isLoading } = useCacheSlice('applications')
  const applications = data as Application[]
  return { applications, isLoading }
}
